import { render, staticRenderFns } from "./AssetEditForm.vue?vue&type=template&id=ad528212&"
import script from "./AssetEditForm.vue?vue&type=script&lang=js&"
export * from "./AssetEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports